export function AuthDivider() {
  return (
    <div className="flex items-center gap-3 my-6">
      <div className="h-px flex-1 bg-border" />
      <span className="text-sm text-muted-foreground">OR</span>
      <div className="h-px flex-1 bg-border" />
    </div>
  );
}
